export default __webpack_public_path__ + "media/images/portfolio/gallery-03-370x470-f274d4c97ec23112489f818ad04876c9.jpg";